/** Preserve diagnostic events while removing bearer invitations and credentials. */
export function redactPublicInvitationData<T>(value: T): T {
  function clean(input: unknown): unknown {
    if (typeof input === "string")
      return input
        .replace(
          /((?:\/api\/public\/quote-requests|\/cotacao-publica)\/)[^/?#\s"'<>\\]+/g,
          "$1[redacted]",
        )
        .replace(/([#&]token=)[^&\s"'<>\\]+/g, "$1[redacted]")
        .replace(
          /\beyJ[A-Za-z0-9_-]+\.[A-Za-z0-9_-]+\.[A-Za-z0-9_-]+\b/g,
          "[redacted-jwt]",
        );
    if (Array.isArray(input)) {
      const mapped: unknown[] = input.map(clean);
      return mapped.some((v, i) => v !== input[i]) ? mapped : input;
    }
    if (
      input &&
      typeof input === "object" &&
      Object.getPrototypeOf(input) === Object.prototype
    ) {
      const record = input as Record<string, unknown>,
        result: Record<string, unknown> = {};
      let changed = false;
      for (const [key, item] of Object.entries(record)) {
        const next =
          /^(publicToken|token|authorization|cookie|(?:temporary|confirm|current|new)?Password)$/i.test(
            key,
          )
            ? "[redacted]"
            : clean(item);
        result[key] = next;
        changed ||= next !== item;
      }
      return changed ? result : input;
    }
    return input;
  }
  return clean(value) as T;
}

export function publicQuoteOperationError(error: unknown): Error {
  const code =
    error &&
    typeof error === "object" &&
    "code" in error &&
    typeof error.code === "string" &&
    /^[A-Z0-9_]{1,40}$/.test(error.code)
      ? error.code
      : "INTERNAL_ERROR";
  return new Error(`Public quotation operation failed (${code}).`);
}
